import type { ComponentProps } from 'react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export type SuggestionsProps = ComponentProps<'section'>;

export const Suggestions = ({ className, children, ...props }: SuggestionsProps) => (
  <section className="w-full" {...props}>
    <div className={cn('flex flex-col gap-2', className)}>{children}</div>
  </section>
);

export type SuggestionProps = Omit<
  ComponentProps<typeof Button>,
  'onClick' | 'children' | 'variant' | 'size' | 'colorScheme'
> & {
  suggestion: string;
  onClick?: (suggestion: string) => void;
};

export const Suggestion = ({
  suggestion,
  onClick,
  className,
  title,
  ...props
}: SuggestionProps) => {
  const handleClick = () => {
    onClick?.(suggestion);
  };

  const resolvedTitle = title ?? suggestion;

  return (
    <Button
      className={cn(
        'h-auto w-full justify-start rounded-xl border-border/70 bg-muted/35 px-3.5 py-1.5 text-left text-xs leading-5 font-normal whitespace-normal break-words line-clamp-2 text-foreground hover:bg-accent hover:border-border',
        className,
      )}
      onClick={handleClick}
      size="sm"
      type="button"
      variant="outline"
      colorScheme="secondary"
      title={resolvedTitle}
      {...props}
    >
      {suggestion}
    </Button>
  );
};
